import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Output,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { CategoryDirective } from '@app/core/directives/category.directive';
import { List } from '@app/core/interfaces/list';
import { SocialLinksComponent } from '@app/layout/social-links/social-links.component';
import { ListingsSelectors } from '@app/store';
import { environment } from '@envs/environment';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, SocialLinksComponent, AsyncPipe, CategoryDirective],
})
export class MenuComponent {
  protected environment = environment;

  @Output()
  closeMenu: EventEmitter<void> = new EventEmitter();

  categories$: Observable<List | undefined> = inject(Store).select(
    ListingsSelectors.categories,
  );

  protected onCloseMenu(): void {
    this.closeMenu.emit();
  }
}
